import { render, staticRenderFns } from "./DriverCreateView.vue?vue&type=template&id=085003fa"
import script from "./DriverCreateView.vue?vue&type=script&lang=js"
export * from "./DriverCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports